const brands = [
    {
      name: "Nike",
      slug: "nike",
      
    },
   
    {
      name: "Libas",
      slug: "libas",
    
    },
    {
      name: "Samsung",
      slug: "samsung",
      
    },
    {
      name: "Adidas",
      slug: "adidas",
      
    }
  ];
  
  export default brands;
  